






















import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { ComponentsConfig, EmpathyXConfig, GridItem, TrackClickEvents } from '../../models';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';
import { SEARCH_GETTERS_KEYS } from '../../store/search/search.const';

@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.search, ['numFound']),
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components,
      config: CONFIG_GETTERS_KEYS.config,
      resultConfig: CONFIG_GETTERS_KEYS.gridResultConfig
    }),
    ...mapGetters(SUBMODULES_PATHS.search, {
      gridItems: SEARCH_GETTERS_KEYS.gridItems,
      hasResults: SEARCH_GETTERS_KEYS.hasResults
    })
  }
})
export default class ResultsGrid extends Vue {
  private components: ComponentsConfig;
  private config: EmpathyXConfig;

  getTrackingEvents(item: GridItem): TrackClickEvents {
    return this.config.resultsGrid.clickEvents[item.modelName];
  }

  getComponentByNamedModel(item: GridItem) {
    const namedComponents: any = this.components.resultsGrid.gridItem;
    if (namedComponents) {
      return namedComponents[item.modelName] || namedComponents.default;
    }
  }
}
